import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import React from 'react'
import { useIntl } from 'react-intl'

import type { AvailableLocale } from 'types/window'

import { areExternalLinksVisible } from 'utils/areExternalLinksVisible'

import m from './messages'

const PRIVACY_POLICY_SEGMENT_BY_LOCALE: Partial<
  Record<AvailableLocale, string>
> = {
  nb: 'no',
}

function getPrivacyPolicyUrl(locale: AvailableLocale) {
  const segment =
    PRIVACY_POLICY_SEGMENT_BY_LOCALE[locale] ?? locale.split('-')[0]

  return segment === 'en'
    ? 'https://www.samesystem.com/privacy-policy/'
    : `https://www.samesystem.com/${segment}/privacy-policy/`
}

function PrivacyPolicyLink() {
  const { formatMessage: f } = useIntl()

  if (!areExternalLinksVisible) return null

  const privacyPolicyUrl = getPrivacyPolicyUrl(window.localeName)

  return (
    <Typography align="center" sx={{ mt: 2 }}>
      {f(m.readPrivacyPolicy, {
        link: (str) => (
          <Button
            component="a"
            data-test-id="page.login.privacyPolicy"
            href={privacyPolicyUrl}
            rel="noopener noreferrer"
            sx={{ verticalAlign: 'baseline' }}
            target="_blank"
            variant="text"
          >
            {str}
          </Button>
        ),
      })}
    </Typography>
  )
}

export default PrivacyPolicyLink
